import { breakpoints, shadow, spacing } from "./build";
import { interimPalette } from "./next/build/interim-palette";
import { semanticPalette } from "./next/build/semantic-palette";
import { createPaletteProxy } from "./next/palette-proxy";
export { customProperties } from "./next/build/custom-properties";
export * from "./build";
export { breakpointKeys, tokens } from "./tokens";
export var tailwind = {
    screens: Object.entries(breakpoints).map(function (_a) {
        var key = _a[0], value = _a[1];
        return [key === "xxl" ? "2xl" : key, value];
    }),
    spacing: Object.fromEntries(Object.entries(spacing).map(function (_a) {
        var key = _a[0], value = _a[1];
        return [key.includes("Base") ? "DEFAULT" : key.replace("space", ""), value];
    })),
    boxShadow: Object.fromEntries(Object.entries(shadow).map(function (_a) {
        var key = _a[0], value = _a[1];
        return [key === "base" ? "DEFAULT" : key === "xxl" ? "2xl" : key, value];
    })),
};
export var wayflyerPalette = createPaletteProxy(interimPalette);
export var wayflyerNextPalette = createPaletteProxy(semanticPalette);
//# sourceMappingURL=index.js.map